module.exports = __webpack_public_path__ + "static/media/Circo2025_08.8a584158.webp";